import React from 'react';

import { useTheme } from '@mui/material';
import Apexchart from 'src/components/Apexchart';
import { Dashboard } from 'src/interfaces/models/Dashboard';

type OpportunitiesGeneralStatusChartProps = {
  data?: Dashboard['opportunitiesStatus'];
};

const OpportunitiesGeneralStatusChart: React.FC<
  OpportunitiesGeneralStatusChartProps
> = ({ data }) => {
  const theme = useTheme();

  return (
    <Apexchart
      type="pie"
      options={{
        title: {
          text: 'Status Geral das Oportunidades',
          align: 'center',
        },
        chart: { id: 'opportunties-general-status' },
        colors: [
          theme.palette.info.light,
          theme.palette.success.light,
          theme.palette.error.light,
        ],
        plotOptions: {
          pie: {
            expandOnClick: true,
          },
        },
        labels: data?.labels || [],
        dataLabels: {
          enabled: true,
          formatter(value) {
            return `${Number(value).toFixed(2)}%`;
          },
        },
      }}
      series={data?.series || []}
    />
  );
};

export default OpportunitiesGeneralStatusChart;
